.select {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: var(--lp-spacing-200);
}

.value {
	flex: 1;
	text-align: start;

	&[data-placeholder] {
		color: var(--lp-color-text-field-placeholder);
	}

	& :is([slot='description']) {
		display: none;
	}
}
